import React, { useState, useContext, useEffect, useRef } from "react";
import { NotificationContext } from "../../Context/NotificationContext";
import AccountNavBar from "../../NewComponents/AccountNavBar";
import NoData from "../../NewComponents/NoData";
import CouponTitleWithSearch from "../../Components/ui/CouponTitleWithSearch";
import { firestore } from "../../firebase.config";
import PopUpModal from "../../NewComponents/PopUpModal";
import { DataContext } from "../../Context/DataContext";
import { AuthContext } from "../../Context/AuthContext";
import { useScreenTransition } from "../../Hooks/useScreenTransition";
import SelectClient from "../Quote/QuoteComponents/SelectClient";
import { ReactComponent as Trash } from "../../assets/icons/Trash.svg";
import SelectMemberTab from "../../NewComponents/SelectMemberTab";


const BlockedUsers = ({ windowSize }) => {
  const { userData } = useContext(DataContext);
  const { signedIn } = useContext(AuthContext);
  const { transitionTo } = useScreenTransition()
  const { showNotification } = useContext(NotificationContext);
  const [filterSearch, setFilterSearch] = useState("");
  const [blockedUsers, setBlockedUsers] = useState([]);
  const [users, setUsers] = useState([]);

  const [filterdCoupons, setFilterdCoupons] = useState([]);
  const [selectedBlockedUser, setSelectedBlockedUser] = useState(null);
  const [blockedIps, setBlockedIps] = useState([]);
  const [addBlockedUserPopUp, setAddBlockedUserPopUp] = useState(false);
  const [blockedUserBtnText, setBlockedUserBtnText] = useState("Block User");

  const [showDetailModal, setShowDetailModal] = useState("");
  let firstLoad = useRef();
  if (!firstLoad.current) firstLoad.current = true;

  let nextPointer = useRef();
  if (!nextPointer.current) nextPointer.current = null;

   useEffect(() => {
      if(!signedIn || (userData && userData.role === "client")){
        return transitionTo("/");
      }
    }, [signedIn, userData]);

  useEffect(() => {
    
    const unsubscribe = firestore
      .collection("blockedUsers")
      .onSnapshot(
        (querySnapshot) => {

            setBlockedUsers(
              querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
            );
        },
        (error) => {
          //console.log(error);
          showNotification(
            "Error",
            "There was an error loading the blocked users. Please, reload the page.",
            "error"
          );
        }
      );

    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    firestore.collection("users").get().then((querySnapshot) => {
      setUsers(querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    });
    
  }, []);

  useEffect(() => {
    firestore.collection("blockedIps").get().then((querySnapshot) => {
      setBlockedIps(querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    });
  }, []);

  useEffect(() => {
    let filterdData = [...blockedUsers];

    if (filterSearch) {
      filterdData = filterdData.filter((item) => {
        return (
          item.email?.includes(filterSearch.trim())
        );
      });
    }
    setFilterdCoupons(filterdData);
  }, [blockedUsers, filterSearch]);


  const addBlockedUser = () => {
    setAddBlockedUserPopUp(true);
  };

  const handleAddBlockedUser = async() => {
    if(selectedBlockedUser){
      setBlockedUserBtnText("Blocking...");
      await firestore.collection("blockedUsers").doc(selectedBlockedUser.email.toLowerCase()).set({
        email: selectedBlockedUser.email.toLowerCase(),
        name: selectedBlockedUser.name.toLowerCase(),
        timestamp: new Date().getTime(),
      });
      setAddBlockedUserPopUp(false);
      setSelectedBlockedUser(null);
      setBlockedUsers([...blockedUsers, selectedBlockedUser]);
      setUsers(users.filter((user) => user.email.toLowerCase() !== selectedBlockedUser.email.toLowerCase()));
      setBlockedUserBtnText("Block User");
    }
  };

  const handleDeleteBlockedUser = async(id) => {
    await firestore.collection("blockedUsers").doc(id).delete();
    setBlockedUsers(blockedUsers.filter((blockedUser) => blockedUser.id !== id));
  };

  return (
    <>
      <AccountNavBar
        windowSize={windowSize}
        selectedTab="blockedUsers"
        accountMainPadding={false}
        admin={true}
        showButton={true}
      >
         <CouponTitleWithSearch
          title="Blocked Users"
          placeholder="Search by Email"
          addBtnText="Add Blocked User"
          onAddMemberClick={addBlockedUser}
          onSearch={(val) => setFilterSearch(val)}
        />
        {addBlockedUserPopUp && (
          <PopUpModal
            title={"Add Blocked User"}
            backBtnText="Cancel"
            btnText={blockedUserBtnText}
            iconBgColor="#FFF6EA"
            alignLeft={true}
            showClose
            deleteBtn={true}
            onClose={() => setAddBlockedUserPopUp(false)}
            onClick={() => {handleAddBlockedUser()}}
            onBackClick={() => setAddBlockedUserPopUp(false)}
            disableBtn={blockedUserBtnText === "Blocking..."}
            contentFullWidth={true}
            components={
              <SelectMemberTab members={users} setSelectedMember={setSelectedBlockedUser} selectedMember={selectedBlockedUser}
                input1Placeholder="Enter name for the Blocked User"
                input2Placeholder="Enter email for the Blocked User"
              />

            }
            hideIcon={true}
          >
          </PopUpModal>
        )}

        {filterdCoupons.length === 0 ? (
          <NoData type="blockedUsers" loading={true} showBtn={false} loadingText={"blockedUsers"}/>
        ) : (
          <div className="accountDetailsScroll">
            <table className="accountDetailsTable">
              <thead>
                <tr>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Email</p>
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Name</p>
                    </div>
                  </th>

                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">IP Address</p>
                    </div>
                  </th>

                  <th></th>
                </tr>
              </thead>
              {blockedUsers.length > 0 && (
                <tbody>
                  {blockedUsers.map((blockedUser, i) => (
                    <tr key={blockedUser.id + i}>
                      <td
                        className="flex gap-2 min-w-[150px]"
                      >
                        <p
                          className="accountDetailsText"
                        >
                          {blockedUser.email || "-"}
                        </p>
                        
                      </td>

                      <td>
                        <p className="accountDetailsText captialLetters"
                        >
                          {blockedUser.name || "-"}
                        </p>
                      </td>

                      <td>
                        <p
                          className="accountDetailsText captialLetters"
                        >
                          {blockedIps.filter((ip) => ip.email === blockedUser.email).map((ip) => ip.ipAddress).join(", ") || "-"}
                        </p>
                      </td>

                      <td>
                        <Trash onClick={() => handleDeleteBlockedUser(blockedUser.id)}/>
                      </td>
                     
                    </tr>
                  ))}
                </tbody>
              )}
            </table>

            {blockedUsers.length === 0 ? (
              <NoData type="blockedUsers" loading={true} showBtn={false} loadingText={"blockedUsers"} />
            ) : null}

          </div>
        )}
      </AccountNavBar>
    </>
  );
};

export default BlockedUsers;
